export const getWaitingPieces = (policyId) =>
  fetch(
    `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/waiting-pj?policyId=`+policyId,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  )
    .then(r => r.json());

export const uploadAndUpdateDocument = (policyId, documentId, body, withTask) => {

  const url = `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/policy/${policyId}/document/${documentId}/${withTask}`;
  return fetch(
    url,
    {
      method: "PATCH",
      body: body
    }
  )
}

export const createTaskForEvidences = async (serviceId, body) => {
  const url = `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/api/relations-clients/createTask/${serviceId}`
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return res.json();
};
